import Button from "common/components/Button/Button";
import { Link } from "react-router-dom";
import useAuth from "common/hooks/useAuth";
import { useTranslation } from "react-i18next";
import Status from "common/components/Status/Status";
import ProfileAvatar from "components/ProfileAvatar/ProfileAvatar";
import dayjs from "dayjs";
import { User } from "types";
import { Profile } from "types/Profile";

function UserItem({ item, onDelete, onNavigate }: any) {
  const { user: currentUser } = useAuth();

  const { email, role, confirmed, blocked, profiles, createdAt } = item as User;
  const canEditItem =
    (role.name !== 'SuperAdmin' || currentUser?.isSuperAdmin) && currentUser?.id !== item.id;

  const editLink = `/users/edit/${item.id}`;

  const { t } = useTranslation();

  return (
    <div className="responsive-flex-lg px-4 py-4 mt-2 w-full relative bg-white cursor-pointer rounded-lg border border-slate-150 transition-all">
      <Link
        to={editLink}
        className={
          !canEditItem
            ? "pointer-events-none responsive-flex-lg flex-1"
            : "responsive-flex-lg flex-1"
        }
      >
        <div className="flex flex-col flex-1 justify-between lg:pl-4 lg:pr-4">
          <div className="flex h-full gap-3">
            <div className="grid w-full gap-1 pt-3 lg:py-0">
              <div className="flex items-center gap-1 mb-1 text-xl">
                <span className="font-bold text-primary leading-4">
                  {email}
                </span>

                <div className="text-xs text-right flex-1 px-1 pt-0 pb-4">
                  {t("forms.subscribedThe", {
                    since: dayjs(createdAt).format("DD/MM/YYYY"),
                  })}
                </div>
              </div>

              <div className="flex flex-row flex-wrap gap-4 items-center ">
                {profiles?.map((profile: Profile) => (
                  <ProfileAvatar
                    profile={profile}
                    key={profile.id}
                    growOnSmallDevice={false}
                    forcedSize="w-12 h-12"
                    forcedCompanyLogoSize="w-7 h-7"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </Link>

      <div className="flex flex-col justify-between items-end text-xs lg:border-l pl-4 min-w-[24em] border-slate-150 gap-2">
        <div className={role ? "flex justify-end gap-2" : ""}>
          {role && <Status status={role?.name} />}
          {!confirmed ? (
            <Status status="not-confirmed" />
          ) : (
            <Status status={blocked ? "blocked" : "active"} />
          )}
        </div>

        <div className="flex w-full items-center justify-end text-slate-500">
          <div>
            <div className="flex w-full gap-1">
              <Button
                type="error-line"
                icon="TrashIcon"
                compact
                onClick={() => onDelete(item.id)}
                disabled={!canEditItem}
                confirmMessage={t("actions.confirmDelete")}
              />
              <Button
                title={t("actions.edit")}
                type="warning-line"
                icon="PencilSquareIcon"
                onClick={() => onNavigate(item.id)}
                disabled={!canEditItem}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserItem;
